import type { CustomIconProps } from '../CustomIcon';

export const EyeIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...props}>
      <path
        d='M1 12.2767C1 12.2767 5 4.27673 12 4.27673C19 4.27673 23 12.2767 23 12.2767C23 12.2767 19 20.2767 12 20.2767C5 20.2767 1 12.2767 1 12.2767Z'
        fill={color}
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 15.2767C13.6569 15.2767 15 13.9336 15 12.2767C15 10.6199 13.6569 9.27673 12 9.27673C10.3431 9.27673 9 10.6199 9 12.2767C9 13.9336 10.3431 15.2767 12 15.2767Z'
        stroke={secondaryColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
